/*
 *
 * ReportsPage reducer
 *
 */

import { fromJS } from "immutable"
import { KEY_ISOLATED_METRICS, setItem } from "../../../utils/storage"
import {
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_QUALITATIVE_WATCHER,
  GET_QUALITATIVE_QUESTIONS_WATCHER,
  GET_QUALITATIVE_QUESTIONS_SUCCESS,
  GET_QUALITATIVE_QUESTIONS_FAILED,
  GET_QUALITATIVE_SUCCESS,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_WATCHER,
  GET_RANKS_WATCHER,
  GET_RANKS_SUCCESS,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MULTIPLE_WATCHER,
  GET_MULTIPLE_SUCCESS,
  GET_MEASURE_INFO_WATCHER,
  GET_MEASURE_INFO_SUCCESS,
  GET_DIMENSIONS_FAILED,
  GET_DIVISIONS_FAILED,
  GET_TEAMS_FAILED,
  GET_RANKS_FAILED,
  GET_MULTIPLE_FAILED,
  GET_QUALITATIVE_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingWidget: true,
  no_process: false,
  isDownloading: false,
  hasOneDivisionAmbassador: [],
  widgetsData: {
    measure: {},
    measure_climate: {},
    dimensions_top: {},
    dimensions_bottom: {},
    dimensions_outcomes: {},
    measure_engagement: {},
    enps: null,
  },
  isLoadingDimensions: true,
  dimensions: [],
  dimensions_drilldown: [],

  isLoadingTeams: true,
  teams: [],
  teams_drilldown: [],

  isLoadingDivisions: true,
  divisions: [],
  divisions_available: [],
  measure_general: [],
  divisions_drilldown: [],
  divisions_general: [],
  metric: {},

  isLoadingQuestions: true,
  questions: [],

  isLoadingMultipleChoiceQuestions: true,
  multipleChoiceQuestions: [],

  isLoadingRanks: true,
  ranks: [],

  isolated_metrics: false,
  measureColorRange: null,

  measureInfo: {},
})

function reportHomeReducer(state = initialState, action) {
  switch (action.type) {
    case GET_STATUS_WATCHER:
      return (
        state
          .set("isLoadingQuestions", true)
          // .set("questions", [])
          .set("isLoadingMultipleChoiceQuestions", true)
          .set("multipleChoiceQuestions", [])
          .set("no_process", false)
          .set("isLoadingWidget", true)
          .set("widgetsData", {
            measure: {},
            measure_climate: {},
            dimensions_top: {},
            dimensions_bottom: {},
            enps: null,
          })
          .set("dimensions", [])
          .set("teams", [])
          .set("isLoadingTeams", true)
          .set("isLoadingRanks", true)
          .set("teams_drilldown", [])
          .set("ranks", [])
      )
    // .set('divisions', [])
    case GET_STATUS_SUCCESS:
      setItem(KEY_ISOLATED_METRICS, action.payload.isolated_metrics || false)
      return (
        state
          .set("isLoadingWidget", false)
          .set(
            "no_process",
            !(
              action.payload.measure_climate &&
              action.payload.measure_climate.percent
            )
          )
          .set("widgetsData", action.payload)
          // .set(
          //   "hasOneDivisionAmbassador",
          //   action.payload.user_type.divisions || []
          // )
          .set("isolated_metrics", action.payload.isolated_metrics || false)
          .set("divisions_available", action.payload.divisions_available)
          .set("measure_general", action.payload.measure_general)
      )
    // Apaga todos los loadings que prende GET_STATUS_WATCHER: si no, quedan girando para siempre
    case GET_STATUS_FAILED:
      return state
        .set("isLoadingWidget", false)
        .set("isLoadingQuestions", false)
        .set("isLoadingMultipleChoiceQuestions", false)
        .set("isLoadingTeams", false)
        .set("isLoadingRanks", false)
        .set("widgetsData", { failed: true })

    case GET_DIMENSIONS_WATCHER:
      return state
        .set("isLoadingDimensions", true)
        .set("dimensions_drilldown", [])

    case GET_DIMENSIONS_SUCCESS:
      return state
        .set("isLoadingDimensions", false)
        .set(
          "dimensions",
          Array.isArray(state.get("dimensions"))
            ? state.get("dimensions").length === 0
              ? action.payload.dimensions
              : state.get("dimensions")
            : action.payload.dimensions
        )
        .set("dimensions_drilldown", action.payload.dimensions_drilldown)

    case GET_DIVISIONS_WATCHER:
      return state
        .set("isLoadingDivisions", true)
        .set("divisions_drilldown", [])
        .set("divisions", [])

    case GET_DIVISIONS_SUCCESS:
      return state
        .set("isLoadingDivisions", false)
        .set("divisions_general", action.payload.divisions_general)
        .set("divisions", action.payload.divisions)
        .set("divisions_drilldown", action.payload.divisions_drilldown)
        .set("metric", action.payload.metric)

    case GET_DIMENSIONS_FAILED:
      return state.set("isLoadingDimensions", false)

    case GET_DIVISIONS_FAILED:
      return state.set("isLoadingDivisions", false)

    case GET_TEAMS_FAILED:
      return state.set("isLoadingTeams", false)

    case GET_RANKS_FAILED:
      return state.set("isLoadingRanks", false)

    case GET_MULTIPLE_FAILED:
      return state.set("isLoadingMultipleChoiceQuestions", false)

    case GET_QUALITATIVE_FAILED:
      return state.set("isLoadingWidget", false).set("isLoadingQuestions", false)

    case GET_QUALITATIVE_WATCHER:
      return state
        .set("isLoadingWidget", true)
        .set("isLoadingQuestions", true)
        .set("questions", [])

    case GET_QUALITATIVE_SUCCESS:
      return state
        .set("isLoadingWidget", false)
        .set("isLoadingQuestions", false)
        .set("questions", action.payload)

    case GET_MULTIPLE_WATCHER:
      return state
        .set("isLoadingMultipleChoiceQuestions", true)
        .set("multipleChoiceQuestions", [])

    case GET_MULTIPLE_SUCCESS:
      return state
        .set("isLoadingMultipleChoiceQuestions", false)
        .set("multipleChoiceQuestions", action.payload)

    case GET_TEAMS_WATCHER:
      return state.set("isLoadingTeams", true).set("teams_drilldown", [])

    case GET_TEAMS_SUCCESS:
      return state
        .set("isLoadingTeams", false)
        .set(
          "teams",
          Array.isArray(state.get("teams"))
            ? state.get("teams").length === 0
              ? action.payload.teams
              : state.get("teams")
            : action.payload.teams
        )
        .set("teams_drilldown", action.payload.teams_drilldown)
        .set("metric", action.payload.metric)

    case GET_RANKS_WATCHER:
      return state.set("isLoadingRanks", true).set("ranks", [])

    case GET_RANKS_SUCCESS:
      return state.set("isLoadingRanks", false).set("ranks", action.payload)

    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set("measureColorRange", action.payload.report_color_range)

    case GET_MEASURE_INFO_WATCHER:
      return state.set("measureInfo", {})

    case GET_MEASURE_INFO_SUCCESS:
      return state.set("measureInfo", action.payload.data)

    case GET_QUALITATIVE_QUESTIONS_WATCHER:
      return state.set("isDownloading", true)
    case GET_QUALITATIVE_QUESTIONS_SUCCESS:
      return state.set("isDownloading", false)
    case GET_QUALITATIVE_QUESTIONS_FAILED:
      return state.set("isDownloading", false)

    default:
      return state
  }
}

export default reportHomeReducer
